import { signOut } from 'firebase/auth';
import { auth } from '../../utils/firebase.js';
import Logo from '../../media/logo.js';
import accountIcon from '../../media/accountIcon.png';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore.js';

function SiteNav(props) {
    const isLoggedIn = useAuthStore((state) => state.isAuthenticated);
    const hasUser = useAuthStore((state) => state.user);

    const navigate = useNavigate();

    const toggleMenu = () => {
        document.getElementById("bgsNavbar").classList.toggle('is-active');
        document.getElementById("bgsBurgerMenu").classList.toggle('is-active');
    }

    const logOut = async () => {
        signOut(auth)
            .then(() => {
                navigate('/');
            });
    }

    const goManageAccount = () => {
        navigate("/manageAccount");
    }

    return (
        <>
            <section className="">
                <div className="navbar is-fixed-top has-background-primary" role="navigation" aria-label="main navigation">
                    <div className="navbar-brand">
                        <div className="is-clickable" onClick={() => { navigate("/") }}><Logo className="" width={11} /></div>
                        <a className="navbar-burger has-text-white" id="bgsBurgerMenu" role="button" aria-label="menu" aria-expanded="false" onClick={toggleMenu}>
                            <span aria-hidden="true"></span>
                            <span aria-hidden="true"></span>
                            <span aria-hidden="true"></span>
                            <span aria-hidden="true"></span>
                        </a>
                    </div>
                    {isLoggedIn &&
                        <div className="navbar-menu" id="bgsNavbar">
                            <div className="navbar-end mr-2">
                                <div className="navbar-item">
                                    <div className='navbar-item is-hidden-touch'>
                                        <button
                                            className="button is-rounded is-white"
                                            style={{ padding: 0, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                            onClick={goManageAccount}>
                                            <img
                                                src={accountIcon}
                                                alt="Account"
                                                style={{ borderRadius: '50%', width: 32, height: 32, objectFit: 'cover' }}
                                            />
                                        </button>
                                    </div>
                                </div>
                                <div className='navbar-item is-hidden-desktop'>
                                    <button className="button has-background-primary-90" onClick={goManageAccount}>Manage Account</button>
                                </div>
                                <div className='navbar-item'>
                                    <button className='button is-outlined is-light' onClick={logOut}>Logout</button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </section>


        </>
    );
}

export default SiteNav;